import request from '@/apis';
import getI18nProps from '@/utils/i18/getI18nProps';
import Snackbar from '@mui/material/Snackbar';
import { styled } from '@mui/material/styles';
import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { GetServerSideProps } from 'next';
import CatchError from '@/components/system/CacthError';

// export const runtime = 'experimental-edge';
const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const Favorites = ({ data: serverData }) => {
  const router = useRouter();
  // const { data, isError, isLoading } = useQuery(['favorites'], () =>
  //   request({ url: '/user/favorites' }),
  // );

  // 定义 removeFromFavorites mutation
  const mutation = useMutation(
    (gameId: string) =>
      request({ url: `/api/user/favorites/${gameId}`, method: 'delete' }),
    {
      // 在成功后，让 react-query 重新获取数据
      // onSuccess: () => {
      //   queryClient.invalidateQueries('favorites');
      // },
    },
  );

  // if (isLoading) {
  //   return <CircularProgress />;
  // }

  return (
    <Container>
      {mutation.isError ? (
        <Snackbar open={true} autoHideDuration={6000}>
          <span>error</span>
          {/*<span>{mutation.error?.message}</span>*/}
        </Snackbar>
      ) : null}
      {mutation.isSuccess ? (
        <Snackbar open={true} autoHideDuration={6000}>
          <span>Game removed from favorites!</span>
        </Snackbar>
      ) : null}
      <span>favorites</span>
      {/*{data.map((game) => (*/}
      {/*  <GameCard key={game.id} game={game} onRemove={mutation.mutate} />*/}
      {/*))}*/}
    </Container>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  req,
}) => {
  return {
    props: {
      ...(await getI18nProps({ locale })),
    },
  };
};

// export const getServerSideProps: GetServerSideProps = async () => {
//   const data = await request({ url: '/user/favorites', method: 'get' });
//   return { props: { data } };
// };

export default CatchError(Favorites);
